export const en = {
    id: 'id',
    'product-description': 'product description',
    'product-name': 'product name'
};
